<template>
  <div class="c-loading-page">
    <div class="c-loading-page__overlay"></div>
    <Loading />
  </div>
</template>

<script lang="ts">
export default {};
</script>
